<template>
  <div class="flex items-center gap-[4px] max-w-[160px] overflow-y-auto py-[12px]">
    <span
      v-if="!contentAmount"
      class="text-[#333333]"
    >-</span>
    <b-overlay
      v-else
      :show="loading"
      class="w-auto"
      spinner-variant="primary"
      spinner-small
      variant="light"
      opacity=".8"
      rounded="sm"
    >
      <div class="flex items-center gap-[4px]">
        <b-form-checkbox
          v-for="index in contentAmount"
          :key="index"
          :checked="checkedList[index - 1]"
          :disabled="loading || disabled"
          class="!m-0"
          :class="disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'"
          @change="toggleCheck(index - 1, $event)"
        />
      </div>
    </b-overlay>
  </div>
</template>

<script>
/**
 * Component for rendering checkboxes for uploaded content tracking.
 * Emits `need-updated` event with the primitive new and old values when a checkbox is clicked.
 */
export default {
  name: 'UploadedCell',
  props: {
    data: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    contentAmount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      checkedList: [],
      lastEmittedValue: this.data.uploaded ?? 0,
    }
  },
  watch: {
    data: {
      handler(newData) {
        const amount = newData.uploaded ?? 0
        const currentCheckedCount = this.checkedList.filter(Boolean).length
        if (currentCheckedCount !== amount) {
          this.checkedList = Array.from({ length: this.contentAmount }, (_, i) => i < amount)
          this.lastEmittedValue = amount
        }
      },
      deep: true,
      immediate: true,
    },
    contentAmount: {
      handler(newAmount) {
        if (this.checkedList.length !== newAmount) {
          const amount = this.data.uploaded ?? 0
          this.checkedList = Array.from({ length: newAmount }, (_, i) => i < amount)
        }
      },
      immediate: true,
    },
  },
  methods: {
    setLoading(state) {
      this.loading = state
    },
    setValue(value) {
      const amount = value ?? 0
      const currentCheckedCount = this.checkedList.filter(Boolean).length
      if (currentCheckedCount !== amount) {
        this.checkedList = Array.from({ length: this.contentAmount }, (_, i) => i < amount)
      }
      this.lastEmittedValue = amount
    },
    toggleCheck(index, checked) {
      if (this.disabled || this.loading) return
      this.$set(this.checkedList, index, checked)
      const newValue = this.checkedList.filter(Boolean).length
      const oldValue = this.lastEmittedValue
      this.$emit('need-updated', { value: newValue, oldValue })
    },
  },
}
</script>

<style scoped>
::v-deep .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #34A770 !important;
  border-color: #34A770 !important;
  box-shadow: none !important;
}
</style>
